import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _BugIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9.875 9.75C10.7034 9.75 11.375 9.07843 11.375 8.25C11.375 7.42157 10.7034 6.75 9.875 6.75C9.04657 6.75 8.375 7.42157 8.375 8.25C8.375 9.07843 9.04657 9.75 9.875 9.75Z"
        fill={iconColor}
      />
      <Path
        d="M15.125 9.75C15.9534 9.75 16.625 9.07843 16.625 8.25C16.625 7.42157 15.9534 6.75 15.125 6.75C14.2966 6.75 13.625 7.42157 13.625 8.25C13.625 9.07843 14.2966 9.75 15.125 9.75Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 11V10.5C21 9.81816 20.9181 9.14476 20.7597 8.49297L22.6513 7.66663C23.1574 7.44554 23.3884 6.85604 23.1673 6.34993C22.9462 5.84383 22.3567 5.61279 21.8506 5.83388L20.0606 6.61583C19.6611 5.83798 19.1403 5.11945 18.5104 4.48959C16.9163 2.89553 14.7543 2 12.5 2C10.2457 2 8.08365 2.89553 6.48959 4.48959C5.85985 5.11933 5.33913 5.83771 4.93957 6.6154L3.15057 5.83388C2.64447 5.61279 2.05497 5.84383 1.83388 6.34993C1.61279 6.85604 1.84383 7.44554 2.34993 7.66663L4.24044 8.49249C4.08196 9.14443 4 9.81799 4 10.5V11H2C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13H4V13.5C4 14.1824 4.08205 14.8563 4.24069 15.5085L2.34993 16.3345C1.84383 16.5556 1.61279 17.1451 1.83388 17.6512C2.05497 18.1573 2.64447 18.3883 3.15057 18.1673L4.94005 17.3855C5.33954 18.1629 5.8601 18.8809 6.48959 19.5104C8.08365 21.1045 10.2457 22 12.5 22C14.7543 22 16.9163 21.1045 18.5104 19.5104C19.14 18.8808 19.6606 18.1626 20.0602 17.3851L21.8506 18.1673C22.3567 18.3883 22.9462 18.1573 23.1673 17.6512C23.3884 17.1451 23.1574 16.5556 22.6513 16.3345L20.7594 15.508C20.918 14.8559 21 14.1822 21 13.5V13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11H21ZM12.5 4C10.7761 4 9.12279 4.68482 7.90381 5.90381C6.68482 7.12279 6 8.77609 6 10.5V11H19V10.5C19 8.77609 18.3152 7.12279 17.0962 5.90381C15.8772 4.68482 14.2239 4 12.5 4ZM19 13H13.5V19.9226C14.8536 19.7119 16.1155 19.0769 17.0962 18.0962C18.3152 16.8772 19 15.2239 19 13.5V13ZM11.5 13H6V13.5C6 15.2239 6.68482 16.8772 7.90381 18.0962C8.88454 19.0769 10.1464 19.7119 11.5 19.9226V13Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const BugIcon = assignWithoutSideEffects(_BugIcon, {
  componentId: 'BugIcon',
});

export default BugIcon;
